// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/grids/GroupsGrid/groupsGrid.css
// module id = 771
// module chunks = 1